import { endpoints } from "../../../configs/Settings";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";
import { HTTPResponseStatus } from "../../../utils/enum";
import * as uuid from "uuid";
import { toast } from "react-toastify";

export async function PostLocation(objData: any, access: any) {
  const uuidValue = uuid.v1();
  const url = `${endpoints.WORKFLOWFHIR}/Location/${uuidValue}`;

  const data = auxiliarData.Location(objData, access, uuidValue);
  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .put(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Created) {
        throw new Error(`PutLocation: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PostLocation ", error);
      // toast.error(`PostLocation Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
